import React from "react";
import { motion } from "framer-motion";

/**
 * Signature masked line-by-line reveal.
 * Each line is a clip-mask; the child span slides from 110% -> 0 with a cubic-bezier easing.
 * Words can also be broken into individual masks by passing splitBy="word".
 */
const MaskedReveal = ({
    lines = [],
    className = "",
    lineClass = "",
    delayBase = 0.12,
    startDelay = 0.2,
    ease = [0.22, 1, 0.36, 1],
    duration = 1.1,
    as = "h1",
    "data-testid": testId,
}) => {
    const Tag = motion[as] || motion.h1;

    return (
        <Tag
            className={className}
            initial="hidden"
            animate="visible"
            data-testid={testId}
        >
            {lines.map((line, i) => (
                <span
                    key={i}
                    className={`mask-line ${lineClass}`}
                    aria-label={typeof line === "string" ? line : undefined}
                >
                    <motion.span
                        variants={{
                            hidden: { y: "110%" },
                            visible: { y: "0%" },
                        }}
                        transition={{
                            duration,
                            ease,
                            delay: startDelay + i * delayBase,
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
};

export default MaskedReveal;
